import { useEffect, useRef, useState } from 'react'

import { PUBLIC_IS_BOT } from '@/app/_constants/search-engines'

import { shuffleItems } from './shuffle-items'

import { IranianWomenItemViewModel } from '../types'

export const useShuffledItems = (itemsData: IranianWomenItemViewModel[] | undefined) => {
    const [shuffledItems, setShuffledItems] = useState<IranianWomenItemViewModel[] | undefined>(undefined)
    const shuffleCacheRef = useRef<{
        source: IranianWomenItemViewModel[] | undefined
        shuffled: IranianWomenItemViewModel[] | undefined
    }>({ source: undefined, shuffled: undefined })

    useEffect(() => {
        if (!itemsData) {
            shuffleCacheRef.current = { source: undefined, shuffled: undefined }
            setShuffledItems(undefined)
            return
        }

        if (shuffleCacheRef.current.source !== itemsData) {
            shuffleCacheRef.current = { source: itemsData, shuffled: shuffleItems(itemsData) }
        }

        setShuffledItems(shuffleCacheRef.current.shuffled)
    }, [itemsData])

    return PUBLIC_IS_BOT ? itemsData : shuffledItems
}
